import {LOOKUP_ENUM} from "../../dictionary/core/lookup.enum";
export const INVENTORY_TYPE_ENUM = LOOKUP_ENUM.INVENTORY_TYPE;
